export default {
  app: {
    privacy: {
      policy: 'политика конфиденциальности',
      expansive: 'Используя Expansive, вы соглашаетесь с {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Сессия истекла',
    sessionExpiredDescription:
      'Ваша сессия истекла. Пожалуйста, войдите снова, чтобы продолжить использовать приложение.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Выберите язык',
      chooseLanguageDescription:
        'Выберите предпочитаемый язык для приложения. Это изменит язык интерфейса и содержимого.',
    },
    userSelection: {
      cancel: 'Отмена',
      createNewUser: 'Их имя отсутствует в списке',
      newUser: 'Новый пользователь',
      selectAnExistingUser: 'Выберите существующего пользователя',
      selectUserHint: 'Выберите существующего пользователя или создайте нового, чтобы продолжить.',
      startTypingToSearch: 'Начните вводить...',
    },
    verification: {
      codeVerification: {
        continue: 'Продолжить',
        header: 'Введите код доступа к объекту',
        invalidCode: 'Неверный код, попробуйте еще раз.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Продолжить без подтверждения местоположения',
        enterSiteAccessCode: 'Введите код доступа к объекту',
        locationNotEnabledOrAvailable: 'Почему я вижу это?',
        notAvailable: {
          description: 'GPS местоположение не поддерживается на этом устройстве.',
          header: 'Местоположение не поддерживается',
        },
        notEnabled: {
          description: 'Службы геолокации не включены или разрешение не предоставлено.',
          header: 'Местоположение не включено',
        },
        notVerified: {
          description: 'GPS показывает, что вы не на объекте.',
          header: 'Местоположение не подтверждено',
        },
        tryAgain: 'Попробовать снова',
        unavailable: {
          description: 'Не удалось подтвердить ваше местоположение по GPS.',
          header: 'Местоположение недоступно',
        },
        unknown: {
          description: 'Не удалось определить ваше местоположение.',
          header: 'Местоположение неизвестно',
        },
        verified: {
          description: 'GPS показывает, что вы на объекте.',
          header: 'Местоположение подтверждено',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Активы не найдены',
        emptyDescription: 'С этим нарядом не связано ни одного актива.',
        warrantyParts: 'Гарантия на детали истекает',
        serialNumber: 'Серийный номер',
        none: '<нет>',
      },
      updates: {
        emptyTitle: 'Обновления не найдены',
        emptyDescription: 'Для этого наряда нет обновлений.',
        unknownUser: 'Неизвестный пользователь',
        none: 'Нет',
        addComment: {
          buttonLabel: 'Добавить комментарий',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Опасности',
          no: 'Нет',
          yes: 'Да',
        },
      },
    },
    attachmentsList: {
      attachments: 'Вложения',
      documents: 'Документы',
      siteDocuments: 'Документы объекта',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Опасности',
        induction: 'Инструктаж',
        safeToProceed: 'Безопасно продолжать',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Срок выполнения',
        activeSessions: 'Активные сессии',
        activeSessionsDescription:
          'Вы уже зарегистрированы в следующих нарядах. Необходимо выйти из этих нарядов перед регистрацией в новом.',
        resumeSession: 'Возобновить',
        startTime: 'Начато в',
        unexpectedErrorTitle: 'Неожиданная ошибка',
        unexpectedErrorMessage:
          'Произошла неожиданная ошибка при создании ваших сессий. Пожалуйста, попробуйте позже.',
        engineerNotFound: 'Инженер не найден',
        engineerNotFoundDescription:
          'Инженер, которого вы пытаетесь зарегистрировать, не найден в системе. Пожалуйста, обратитесь к администратору.',
      },
      verification: {
        code: {
          description:
            'Для регистрации получите 4-значный код у менеджера объекта или назначенного контактного лица.',
        },
        geo: {
          continue: 'Продолжить',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Пожалуйста, получите код доступа у руководителя объекта или назначенного контакта для завершения вашего визита.',
            checkOut: 'Выйти',
            completeBeforeLeaving: 'Пожалуйста, заполните следующую форму перед уходом.',
            continue: 'Продолжить',
            noResolutionSelected: 'Пожалуйста, выберите решение перед продолжением.',
            quoteRequired: {
              hint: 'Визит завершен, будет предоставлена смета',
              label: 'Требуется смета',
            },
            returnVisitRequired: {
              hint: 'Мы вернемся для завершения',
              label: 'Требуется повторный визит',
            },
            serviceCompleted: {
              hint: 'Дальнейших действий не требуется',
              label: 'Сервис завершен',
            },
            uploadCheckout: 'Загрузите файл, фото или видео',
            visitNotes: 'Заметки о визите',
            workOrderResolution: 'Решение по наряду',
            enterNotes: 'Введите любые заметки здесь...',
            errors: {
              timedOut:
                'Время ожидания истекло, превышено 30 секунд. Пожалуйста, попробуйте снова.',
              closingSession: 'Ошибка при закрытии сессии',
            },
          },
          success: {
            description:
              'Спасибо за визит {site}. | На {site} остался 1 открытый наряд. | На {site} осталось {count} открытых нарядов.',
            endVisit: 'Завершить визит',
            header: 'Вы успешно вышли',
            viewWorkOrders: 'Зарегистрироваться в другом наряде',
          },
          verification: {
            code: {
              description:
                'Для выхода получите 4-значный код у менеджера объекта или назначенного контактного лица.',
              continue: 'Продолжить',
            },
            geo: {
              checkOut: 'Выйти',
              continue: 'Продолжить',
            },
          },
        },
        detail: {
          assets: 'Активы',
          call: 'Позвонить',
          checkOut: 'Выйти',
          closed: 'Закрыто',
          details: 'Детали',
          dueBy: 'Срок выполнения',
          manageEngineers: 'Управление инженерами',
          notAvailable: 'Недоступно',
          pointOfContact: 'Контактное лицо',
          siteAccessTimes: 'Время доступа к объекту',
          siteAccessInstructions: 'Инструкции по доступу',
          siteAddress: 'Адрес объекта',
          siteNotes: 'Заметки объекта',
          siteTelephone: 'Телефон объекта',
          siteLocation: 'Местоположение объекта',
          updates: 'Обновления',
          more: 'Еще',
          mismatchErrorTitle: 'Ошибка наряда',
          mismatchErrorMessage:
            'Наряд, к которому вы пытаетесь получить доступ, не совпадает с тем, в который вы сейчас зарегистрированы. Пожалуйста, проверьте наряд и попробуйте снова.',
          siteDocuments: 'Документы объекта',
          validFrom: 'Действительно с',
          validUntil: 'Действительно до',
          documentName: 'Название документа',
          documentType: 'Тип документа',
          attachments: 'Файлы наряда',
          download: 'Скачать',
          workDetails: 'Детали работы',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Добавить помощника инженера',
            assistantEngineers: 'Помощники инженера',
            description: 'В целях безопасности укажите имена всех инженеров на объекте.',
            editMainEngineer: 'Редактировать главного инженера',
            errors: {
              creatingEngineer: 'Ошибка при создании инженера',
              creatingSession: 'Ошибка при создании сессии',
            },
            header: 'Инженеры на объекте',
            mainEngineer: 'Главный инженер',
            newAssistantEngineer: 'Введите их полное имя',
            next: 'Далее',
            removeEngineer: 'Удалить инженера',
            selectExistingAssistantEngineer: 'Начните вводить их имя',
          },
          index: {
            description: 'В целях безопасности укажите имена всех инженеров на объекте.',
            errorCreatingEngineer: 'Ошибка при создании инженера, попробуйте снова.',
            header: 'Инженеры на объекте',
            hintMainEngineer: 'Введите полное имя главного инженера',
            newMainEngineer: 'Новый главный инженер',
            next: 'Далее',
            selectExistingMainEngineer: 'Выберите существующего главного инженера',
            yes: 'Да',
            no: 'Нет',
            mainEngineerLabel: 'Вы главный инженер?',
          },
        },
        index: {
          callUsOn: 'Позвоните нам по номеру {phoneNumber}',
          description: 'Не можете найти то, что ищете?',
          dueBy: 'Срок выполнения',
          header: 'Выберите наряд',
          notAvailable: 'Недоступно',
          searchWorkOrders: 'Поиск нарядов...',
        },
        manageEngineers: {
          manageEngineers: 'Управление инженерами',
          notWorking: 'Неактивные работники',
          pause: 'Пауза',
          resume: 'Возобновить',
          workingNow: 'Активные работники',
          startTime: 'Время начала',
          endTime: 'Время окончания',
          duration: 'Длительность',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Обратная связь',
            feedbackDescription:
              'Пожалуйста, оставьте отзыв о наряде, чтобы мы могли улучшить наши услуги.',
            feedbackLabel: 'Обратная связь',
            filesLabel: 'Вложения',
            submissionLabel: 'Отправить отзыв',
          },
          hazards: {
            back: 'Назад',
            hazards: 'Опасности',
            next: 'Далее',
            no: 'Нет',
            noTasksForHazard: 'Нет задач для этой опасности.',
            yes: 'Да',
          },
          induction: {
            continue: 'Продолжить',
            induction: 'Инструктаж',
          },
          index: {
            checkIn: 'Зарегистрироваться',
            description: 'Пожалуйста, выполните следующую оценку рисков для выбранной работы.',
            fail: 'Не удалось обработать проверку начала работ.',
            haltMessage:
              'Обнаружены потенциальные риски. Пожалуйста, прекратите работу, ознакомьтесь с инструкциями по безопасности и свяжитесь с руководителем.',
            header: 'Проверки перед началом работ',
            endVisit: 'Завершить визит',
            leaveFeedback: 'Оставить отзыв',
          },
          safeToProceed: {
            continue: 'Продолжить',
            safeToProceed: 'Безопасно продолжать',
          },
        },
      },
    },
    index: {
      title: 'Добро пожаловать',
      description: 'Отсканируйте QR-код на вашем объекте, чтобы начать.',
    },
    login: {
      errorTitle: 'Неожиданная ошибка',
      errorMessage:
        'Произошла неожиданная ошибка. Пожалуйста, попробуйте отсканировать QR-код снова.',
    },
    unauthenticated: {
      welcome: {
        title: 'Добро пожаловать в {site}',
        description:
          'Прежде чем мы покажем вам наряды, нам нужно подтвердить ваши данные. Нажмите кнопку ниже, чтобы продолжить.',
        next: 'Продолжить',
      },
      index: {
        errorTitle: 'Неожиданная ошибка',
        errorMessage:
          'Произошла неожиданная ошибка. Пожалуйста, попробуйте отсканировать QR-код снова.',
      },
      contractor: {
        title: 'На кого вы работаете?',
        contractor: 'Подрядчик',
        contractorLabel: 'Начните вводить название вашей компании',
        contractorHint: 'Введите не менее 3 символов для отображения результатов',
        defaultSelectPlaceholder: '--Пожалуйста, выберите--',
        next: 'Далее',
      },
      user: {
        title: 'Кто вы?',
        cancel: 'Отмена',
        createNewUserLabel: 'Меня нет в списке',
        existingUserLabel: 'Начните вводить ваше имя',
        existingUserHint: 'Введите не менее 3 символов для отображения результатов',
        newUserLabel: 'Введите ваше полное имя',
        next: 'Далее',
        user: 'Пользователь',
      },
      verification: {
        methods: {
          add: {
            add: 'Добавить способ верификации',
            defaultSelectPlaceholder: '--Пожалуйста, выберите--',
            emailLabel: 'Электронная почта',
            existingMethodWarning:
              'У вас уже есть ожидающий подтверждения способ верификации. Добавление нового заменит его.',
            method: 'Способ',
            methodLabel: 'Способ',
            mobileCountryHint: 'Пожалуйста, выберите код страны',
            mobileCountryLabel: 'Код страны мобильного',
            mobileHint: 'Пожалуйста, введите ваш мобильный номер',
            mobileLabel: 'Мобильный',
            title: 'Добавить способ верификации',
          },
          confirm: {
            confirm: 'Подтвердить',
            description: 'Пожалуйста, подтвердите способ верификации для продолжения.',
            label: 'Введите ваш код',
            resend: 'Отправить снова',
            resendPrompt: 'Не получили код?',
            title: 'Подтвердите способ верификации',
          },
          confirmed: {
            description:
              'Вы получите уведомление, когда этот способ верификации будет одобрен администратором, после чего сможете использовать его для подтверждения личности.',
            forceApproval: 'Пока не одобрено, вы не можете получить доступ к нарядам.',
            nonForceApproval:
              'Пока вы ожидаете одобрения, вы можете продолжить работу с ограниченным доступом.',
            nonForceApprovalButtonLabel: 'Продолжить с ограниченным доступом',
            title: 'Ожидание одобрения',
          },
          addNew: 'Добавить новый способ верификации',
          description:
            'Нам нужно подтвердить вашу личность, чтобы предоставить полный доступ к наряду.',
          email: 'Электронная почта',
          hint: 'Мы отправим ссылку на выбранный способ верификации, чтобы предоставить полный доступ к наряду. Если нужно изменить существующие способы, обратитесь к администратору.',
          label: 'Выберите способ верификации',
          next: 'Далее',
          pendingHint: 'Ожидание одобрения администратором',
          sms: 'SMS',
          title: 'Верификация',
        },
        optional: {
          hint: 'Верификация ваших данных даст полный доступ к наряду',
          label: 'Хотите верифицировать ваши данные?',
          next: 'Далее',
          no: 'Нет',
          noHint:
            'Я не хочу верифицировать свои данные и продолжу с ограниченным доступом к наряду',
          title: 'Верификация',
          yes: 'Да',
          yesHint: 'Я хочу верифицировать свои данные и получить полный доступ к наряду',
        },
        sent: {
          description:
            'Ссылка для входа отправлена на {identifier}. Пожалуйста, перейдите по ссылке для завершения входа.',
          title: 'Ссылка для входа отправлена',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Вчера',
      today: 'Сегодня',
      days: {
        monday: 'Понедельник',
        tuesday: 'Вторник',
        wednesday: 'Среда',
        thursday: 'Четверг',
        friday: 'Пятница',
        saturday: 'Суббота',
        sunday: 'Воскресенье',
      },
      months: {
        january: 'Январь',
        february: 'Февраль',
        march: 'Март',
        april: 'Апрель',
        may: 'Май',
        june: 'Июнь',
        july: 'Июль',
        august: 'Август',
        september: 'Сентябрь',
        october: 'Октябрь',
        november: 'Ноябрь',
        december: 'Декабрь',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Что-то пошло не так',
      message: 'Пожалуйста, попробуйте отсканировать QR-код снова.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Неизвестный пользователь',
      },
      none: 'Нет',
      types: {
        stateTransition: 'Статус изменен',
        contractorAssigned: 'Назначен подрядчик',
        engineerAssigned: 'Назначен инженер',
        serviceAssigned: 'Назначена услуга',
        priorityChanged: 'Приоритет изменен',
        actionableDateChanged: 'Дата выполнения изменена',
        dueDateChanged: 'Срок изменен',
        etaDateChanged: 'Изменена расчетная дата прибытия',
        spendLimitApproved: 'Лимит расходов одобрен',
        spendLimitCancelled: 'Запрос на лимит расходов отменен',
        spendLimitRejected: 'Лимит расходов отклонен',
        spendLimitRequested: 'Запрошен лимит расходов',
        jobSheetUploaded: 'Загружен лист задания',
        slaAlertSent: 'Время реагирования превысило SLA',
        issuedWorkPermit: 'Выдано разрешение на работу',
        requestForServiceSent: 'Отправлен запрос на услугу',
        comment: 'Добавлен комментарий',
        unknown: 'Неизвестное событие',
      },
      labels: {
        actionableDate: 'Дата выполнения',
        comment: 'Комментарий',
        file: 'Файл',
        contractor: 'Подрядчик',
        dueDate: 'Срок',
        etaDate: 'Расчетная дата прибытия',
        engineer: 'Инженер',
        priority: 'Приоритет',
        requestForService: 'Запрос на услугу',
        service: 'Услуга',
        spendLimit: 'Лимит расходов',
        status: 'Статус',
        workPermit: 'Разрешение на работу',
      },
    },
  },
}
